import { useEffect } from 'react';
import { Outlet, useNavigate } from '@tanstack/react-router';
import { useAuth, isAdmin } from '@/lib/auth';

export function TutorAdminLayout() {
  const { profile, user, loading, profileLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading || profileLoading) return;
    if (!isAdmin(profile, user?.email)) {
      navigate({ to: '/tutor/dashboard' });
    }
  }, [loading, profileLoading, profile, user, navigate]);

  if (loading || profileLoading) return null;
  if (!isAdmin(profile, user?.email)) return null;

  return <Outlet />;
}
